import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { authActions } from './auth';

interface VaultiCrawlState {
  selectedCustomerId: string | null;
  selectedClientId: string | null;
}

const initialState: VaultiCrawlState = {
  selectedCustomerId: null,
  selectedClientId: null,
};

const vaultiCrawlSlice = createSlice({
  name: 'vaultiCrawl',
  initialState,
  reducers: {
    setCrawlSelection(
      state,
      action: PayloadAction<{ customerId: string | null; clientId: string | null }>
    ) {
      state.selectedCustomerId = action.payload.customerId;
      state.selectedClientId = action.payload.clientId;
    },
    clearCrawlSelection(state) {
      state.selectedCustomerId = null;
      state.selectedClientId = null;
    },
  },
  extraReducers: (builder) => {
    // Clear crawl selection on logout (matches vaultilake slice pattern)
    builder.addCase(authActions.logout, () => initialState);
  },
});

export const { setCrawlSelection, clearCrawlSelection } = vaultiCrawlSlice.actions;
export default vaultiCrawlSlice.reducer;
